import * as React from "react";
import { Dropdown, Input } from "semantic-ui-react";
import PlayerCardField from "./Fields/PlayerCardField";
import { LIQUID_PLACEHOLDER_REGEX } from "../../../../../utils/liquidHelpers";
import CustomTitleField from "./Fields/CustomTitleField";
import DisplayFieldLabel from "./Fields/DisplayFieldLabel";
import { useFormContext, useWatch } from "react-hook-form";
import { PolymorphicPlayerCard } from "../../../../../services/bedrock";
import { useEffect } from "react";

interface PhoneWidgetSettingsProps {
  index: number;
}

const PhoneWidgetSettings: React.FC<PhoneWidgetSettingsProps> = ({ index }) => {
  const [options, setOptions] = React.useState([
    { key: "Mobile", value: "Mobile", text: "Mobile" },
    { key: "Home", value: "Home", text: "Home" },
    { key: "Work", value: "Work", text: "Work" },
  ]);

  const { control } = useFormContext<PolymorphicPlayerCard>();
  const watchedType = useWatch({ control, name: `widgets.${index}.owner.phoneType` });

  useEffect(() => {
    if (!watchedType) return;
    setOptions(prev => {
      if (prev.some(o => o.value === watchedType)) {
        return prev;
      } else {
        return [...prev, { key: watchedType, value: watchedType, text: watchedType }];
      }
    });
  }, [watchedType]);

  return (
    <div className="playerCardWidgetOwner playerCardPhone">
      <div className="playerCardInputsRow">
        <PlayerCardField
          index={index}
          fieldName="phoneNumber"
          rules={{
            required: "This is required.",
            validate: (value: string) => {
              try {
                const phoneRegex = /^(\+?\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
                const liquidRegex = new RegExp(`^(${LIQUID_PLACEHOLDER_REGEX.source})$`);
                if (phoneRegex.test(value) || liquidRegex.test(value)) {
                  return true;
                } else {
                  return "Please enter a valid phone number";
                }
              } catch {
                return "Please enter a valid phone number";
              }
            },
          }}
          component={Input}
          fieldLabel="Phone Number"
          placeholder="Phone Number"
          autoComplete="tel"
        />
        <PlayerCardField
          index={index}
          fieldName="phoneType"
          component={Dropdown}
          fieldLabel={<DisplayFieldLabel index={index} label="Type" fieldName="displayPhoneType" />}
          placeholder="Type"
          selection
          search
          clearable
          options={options}
          allowAdditions
        />
      </div>
      <CustomTitleField index={index} />
    </div>
  );
};
export default PhoneWidgetSettings;
